import Alert from '@storeblocks/alert';
import { ElectricScooterDetails } from 'Api/insurance';
import { WrapMdMarginBottom } from 'App/global-style';
import { useFormikContext } from 'formik';
import { useGetDisabledFields } from 'Forms/CancelFormV2/cancelForm.hooks';
import { CancelReason } from 'Forms/CancelFormV2/components/CancelReason';
import React from 'react';
import { getAppText } from 'Utils/text';
import { getElectricScooterCancellationOptions } from '../cancelElectricScooterForm.helpers';
import {
  CancelElectricScooterFormValues,
  CancelReasonElectricScooter,
} from '../cancelElectricScooterForm.types';

interface CancelElectricScooterFormFieldsProps {
  insurance: ElectricScooterDetails;
}

export const CancelElectricScooterFormFields = ({
  insurance,
}: CancelElectricScooterFormFieldsProps): React.ReactElement => {
  const fieldsDisabled = useGetDisabledFields(insurance);
  const { values } = useFormikContext<CancelElectricScooterFormValues>();

  return (
    <>
      <CancelReason
        disabled={fieldsDisabled}
        options={getElectricScooterCancellationOptions()}
      />

      {values.cancelReason ===
        CancelReasonElectricScooter.BROKEN_AND_RECYCLED && (
        <WrapMdMarginBottom>
          <Alert
            title={getAppText('cancel.electricScooter.alert.recycling.title')}
            description={getAppText(
              'cancel.electricScooter.alert.recycling.description',
            )}
            variant="info"
          />
        </WrapMdMarginBottom>
      )}
    </>
  );
};
